import { addNotification, getSessionSaga, reduceLoading } from 'metrix-common3';
import { call, put } from 'redux-saga/effects';
import { getPolicySaga } from './getPolicySaga';
import { getPolicySummarySaga } from './getPolicySummarySaga';

export function* quoteCancellationSaga(action) {
    try {
        yield put(reduceLoading({ code: 'quoteCancellation', value: true }));
        const session = yield getSessionSaga();

        const response = yield call(fetch, '/api/policyCancellation/quote', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                Accept: 'application/json',
                Authorization: session.authenticationToken.token,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                policyTransactionGuid: action.payload.policyTransactionGuid,
            }),
        });

        const result = yield call([response, 'json']);
        yield put(reduceLoading({ code: 'quoteCancellation', value: false }));

        if (result.operation?.status) {
            yield put(
                addNotification({
                    code: 'quoteCancellation',
                    type: 'success',
                    message: action.payload.successMessage,
                }),
            );
            // Refresh in place so the transaction reflects the Quoted status and the computed refund.
            yield getPolicySaga();
            yield getPolicySummarySaga();
        } else {
            yield put(
                addNotification({
                    code: 'quoteCancellation',
                    type: 'error',
                    errors: result.operation?.errors,
                    message: action.payload.errorMessage,
                }),
            );
        }
    } catch (error) {
        console.log('Error while quoting Cancellation API - ', error);
        yield put(reduceLoading({ code: 'quoteCancellation', value: false }));
        yield put(
            addNotification({
                code: 'quoteCancellation',
                type: 'error',
                message: action.payload.errorMessage,
            }),
        );
    }
}
